<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="content"></a><a id="page_ix">Contents</a></h2><a id="page_ix">
</a><p class="contib"><a id="page_ix"></a><a href="#/xhtml/authornote"><span class="txit">Author’s Note</span></a></p>
<p class="cont"><a href="#/xhtml/ch01">1. Grover Cleveland: The Mysterious Case of the Disappearing President</a></p>
<p class="cont"><a href="#/xhtml/ch02">2. “I Did Not Kill Armstrong”: The War of Wills in the Early Days of Radio</a></p>
<p class="cont"><span href="#/xhtml/ch03" title="Link target outside of Sample">3. Woodrow Wilson: A Masterful Stroke of Deception</span></p>
<p class="cont"><span href="#/xhtml/ch04" title="Link target outside of Sample">4. Streets of Gold: Charles Ponzi and the American Scheme</span></p>
<p class="cont"><span href="#/xhtml/ch05" title="Link target outside of Sample">5. He Loved Lucy: The Tragic Genius of Desi Arnaz, the Inventor of the Rerun</span></p>
<p class="cont"><span href="#/xhtml/ch06" title="Link target outside of Sample">6. The Muckraker: How a Lost Letter Revealed Upton Sinclair’s Deception</span></p>
<p class="cont"><span href="#/xhtml/ch07" title="Link target outside of Sample">7. Alan Turing: How the Father of the Computer Saved the World for Democracy</span></p>
<p class="cont"><span href="#/xhtml/ch08" title="Link target outside of Sample">8. The Spy Who Turned to a Pumpkin: Alger Hiss and the Liberal Establishment That Defended a Traitor</span></p>
<p class="cont"><span href="#/xhtml/ch09" title="Link target outside of Sample">9. The City of Tomorrow: Walt Disney’s Last and Lost Dream</span></p>
<p class="contb"><span href="#/xhtml/ch10" title="Link target outside of Sample">10. “Make It Great, John”: How Steve Jobs and John Lasseter Changed History at Pixar</span></p>
<p class="conti"><span href="#/xhtml/appendix" title="Link target outside of Sample"><span class="txit">Appendix: Letter from Upton Sinclair</span></span></p>
<p class="conti"><span href="#/xhtml/author" title="Link target outside of Sample"><span class="txit">About Glenn Beck</span></span></p>
<p class="conti1"><span href="#/xhtml/book" title="Link target outside of Sample"><span class="txit">About the Writing of This Book</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?75c70a67